import {http} from './Config' 

export default{

    get: (cnpj)=>{
            return http.get( `https://ut9vsgl2mh.execute-api.us-east-1.amazonaws.com/dev/cnpj/info/${cnpj}`)
    }
}